import { render, staticRenderFns } from "./AdminDetailPage.vue?vue&type=template&id=32dddce7&scoped=true&lang=pug&"
import script from "./AdminDetailPage.vue?vue&type=script&lang=js&"
export * from "./AdminDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetailPage.vue?vue&type=style&index=0&id=32dddce7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dddce7",
  null
  
)

export default component.exports